let Variant = /*#__PURE__*/function (Variant) {
  Variant["Primary"] = "primary";
  Variant["Secondary"] = "secondary";
  Variant["Tertiary"] = "tertiary";
  Variant["Text"] = "text";
  return Variant;
}({});
let Theme = /*#__PURE__*/function (Theme) {
  Theme["Default"] = "default";
  Theme["Success"] = "success";
  Theme["Warning"] = "warning";
  Theme["Error"] = "error";
  return Theme;
}({});
let Size = /*#__PURE__*/function (Size) {
  Size["Default"] = "default";
  Size["Large"] = "large";
  Size["Small"] = "small";
  Size["XSmall"] = "xsmall";
  return Size;
}({});
let Width = /*#__PURE__*/function (Width) {
  Width["Default"] = "default";
  Width["Fill"] = "fill";
  return Width;
}({});
let Truncate = /*#__PURE__*/function (Truncate) {
  Truncate["Default"] = "default";
  Truncate["Ellipsis"] = "ellipsis";
  return Truncate;
}({});
let Target = /*#__PURE__*/function (Target) {
  Target["Default"] = "_self";
  Target["Blank"] = "_blank";
  Target["Parent"] = "_parent";
  Target["Top"] = "_top";
  return Target;
}({});
export { Size as S, Theme as T, Variant as V, Width as W, Target as a, Truncate as b };